exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumb{\r\n  margin-top:10px;\r\n}\r\n.mycontent-left,.mycontent-right{\r\ntext-align:center;\r\n  /* padding: 20px 1px 1px 1px; */\r\n  /* padding-right: 3px;\r\ntext-align:center\r\n  /* font-size:25px; */\r\n\r\n}\r\n\r\n\r\np{\r\n  text-align: center;\r\n  font-family:roboto;\r\n  font-size:15px;\r\n\r\n}\r\nh5{\r\n  font-size: 22px;\r\n  color:#007B85;\r\n  text-align: center;\r\n  font-family:roboto;\r\n  /* font-sise:bolder; */\r\n}\r\nbutton{\r\n  border-radius:25px 25px 25px 25px;\r\n\r\n}\r\n.fa fa-file-text-o{\r\n  text-align:center;\r\n  font-size:20px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/mass-search-customers/mass-search-customers.component.css
// module id = 464
// module chunks = 1